
import createIconComponent from '../utils/createIconComponent';
import { SVG_TIME_LIMIT_FILLED } from '../../../dist';
import React from 'react';
const TimeLimitFilledIcon = createIconComponent({ content: SVG_TIME_LIMIT_FILLED, height: 24, width: 24 });
TimeLimitFilledIcon.displayName = 'TimeLimitFilledIcon';
export default TimeLimitFilledIcon;
